/**
 * Stable CSS class names for E2E — Schedule Groups (group list) page.
 */
export const SG = {
    page: 'schedule-groups-page',
    loadingSection: 'schedule-groups-page__loading-section',
    layout: 'schedule-groups-page__layout',

    breadcrumbCol: 'schedule-groups-page__breadcrumb-col',
    addGroupCol: 'schedule-groups-page__add-group-col',
    addGroupButton: 'schedule-groups-page-input--button-add-group',

    emptyState: 'schedule-groups-page__empty-state',
    emptyText: 'schedule-groups-page__empty-text',

    searchRow: 'schedule-groups-page__search-row',
    searchInput: 'schedule-groups-page-input__search-group',

    tableOuterPaper: 'schedule-groups-page__table-outer-paper',
    tableContainer: 'schedule-groups-page__table-container',
    table: 'schedule-groups-page__table',
    tableHead: 'schedule-groups-page__table-head',
    tableHeadRow: 'schedule-groups-page__table-head-row',
    tableHeadCell: 'schedule-groups-page__table-head-cell',
    tableBody: 'schedule-groups-page__table-body',
    tableRow: 'schedule-groups-page__table-row',
    tableCell: 'schedule-groups-page__table-cell',
    tableCellGroupName: 'schedule-groups-page__table-cell--group-name',
    tableCellEdit: 'schedule-groups-page__table-cell--edit',
    tableCellUsers: 'schedule-groups-page__table-cell--users',
    tableCellActive: 'schedule-groups-page__table-cell--active',

    editGroupButton: 'schedule-groups-page-input--button-edit-group',
    editGroupIcon: 'schedule-groups-page__edit-group-icon',
    editUsersButton: 'schedule-groups-page-input--button-edit-users',
    editUsersIcon: 'schedule-groups-page__edit-users-icon',
    activeIconWrap: 'schedule-groups-page__active-icon-wrap',
    activeIconSuccess: 'schedule-groups-page__active-icon--success',
    activeIconError: 'schedule-groups-page__active-icon--error',
} as const;

export const sgCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

